import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';
import {
  makeStyles,
  TextField,
  ListItemText,
  Chip,
  ListItem,
  ListItemIcon,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { getIconForEventData } from '../../../utils/eventDataHelper';
import styles from './styles';

const useStyles = makeStyles(styles);

export const EventDataAutocompleteComponent = (props) => {
  const {
    disabled,
    multiple,
    error,
    label,
    helperText,
    eventData: eventDataProps,
    value,
    onChange,
  } = props;
  const eventData = sortBy(eventDataProps, ['order', 'name']);
  const classes = useStyles();

  // local state
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e) => {
    const changedValue = e.target.value;
    setInputValue(changedValue);
  };

  const handleFilterOptions = (options) => {
    if (!multiple) {
      return options;
    }
    const returnOptions = [];
    for (let i = 0; i < options.length; i += 1) {
      if (value.map((eventTemplate) => eventTemplate.id).indexOf(options[i].id) < 0) {
        returnOptions.push(options[i]);
      }
    }
    return returnOptions;
  };

  const renderSuggestion = (
    suggestion,
  ) => (
    <React.Fragment>
      <ListItem
        dense
        value={suggestion}
        key={suggestion.id}
        component="div"
      >
        <ListItemIcon>
          {getIconForEventData(suggestion, classes.eventDataIcon)}
        </ListItemIcon>
        <ListItemText primary={suggestion.name} secondary={suggestion.type} />
      </ListItem>
    </React.Fragment>
  );

  return (
    <Autocomplete
      disabled={disabled}
      multiple={multiple}
      id="select-custom-fields-outlined"
      options={eventData}
      filterSelectedOptions
      getOptionLabel={(option) => option.name}
      filterOptions={handleFilterOptions}
      value={value}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          error={error}
          helperText={helperText}
          margin="normal"
          variant="outlined"
          label={label}
          placeholder="Search custom fields"
          fullWidth
          onChange={handleInputChange}
          value={inputValue}
          autoComplete="off"
        />
      )}
      renderOption={renderSuggestion}
      renderTags={(tagValue, getTagProps) => tagValue.map((et, index) => (
        <Chip label={et.name} {...getTagProps({ index })} />
      ))}
      disableCloseOnSelect
    />
  );
};

EventDataAutocompleteComponent.propTypes = {
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  label: PropTypes.string,
  helperText: PropTypes.string,
  eventData: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
};
EventDataAutocompleteComponent.defaultProps = {
  multiple: false,
  disabled: false,
  error: false,
  label: 'Custom Fields',
  helperText: '',
  eventData: [],
  value: null,
  onChange: () => {},
};

export default (EventDataAutocompleteComponent);
